import { render } from "./UploadField.vue?vue&type=template&id=84574494&scoped=true"
import script from "./UploadField.vue?vue&type=script&lang=js"
export * from "./UploadField.vue?vue&type=script&lang=js"

import "./UploadField.vue?vue&type=style&index=0&id=84574494&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84574494"]])

export default __exports__